// Convert a structured article (from `src/data/articles.js`) into an HTML
// string that mirrors what `ArticleSection.jsx` renders on the site. Used by
// the Admin "Pull from site" button so admins can populate the WYSIWYG
// editor with the currently-rendered copy of an article that lives as
// structured data (rather than pre-authored `body_html`) — a prerequisite
// for the Regenerate-PDF flow on legacy static articles.

const esc = (s) =>
    String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

const renderList = (list) => {
    if (!Array.isArray(list) || !list.length) return "";
    const items = list
        .map(
            (it) =>
                `<dt>${esc(it.term)}</dt><dd>${esc(it.detail)}</dd>`,
        )
        .join("");
    return `<dl>${items}</dl>`;
};

const renderBody = (body) =>
    Array.isArray(body)
        ? body.map((p) => `<p>${esc(p)}</p>`).join("")
        : "";

const renderSubsections = (subs) => {
    if (!Array.isArray(subs) || !subs.length) return "";
    return subs
        .map(
            (sub) =>
                `<h3>${esc(sub.heading || "")}</h3>`
                + renderBody(sub.body)
                + renderList(sub.list),
        )
        .join("");
};

export function articleToHtml(article) {
    if (!article || !Array.isArray(article.sections)) return "";
    return article.sections
        .map(
            (s) =>
                `<h2>${esc(s.heading || "")}</h2>`
                + renderBody(s.body)
                + renderList(s.list)
                + renderSubsections(s.subsections),
        )
        .join("");
}
